export default {
  state: {
    mtech: {
      enabled: false,
      leg1: {
        services: [],
        pickupDate: ''
      },
      markup: {
        type: '%',
        value: 0
      }
    },
    quoteId: ''
  },
  mutations: {
    setMtechData (state, data) {
      for (let field in data) {
        state.mtech[field] = data[field]
      }
    },
    setMtechLegData (state, data) {
      if (data.leg === 'leg2') return
      for (let field in data.fields) {
        state.mtech[data.leg][field] = data.fields[field]
      }
    },
    setQuoteId (state, val) {
      state.quoteId = val
    },
    setMtechNewPricing (state, data) {
      if (
        !Object.keys(state.mtech.leg1.services).length ||
        !state.mtech.leg1.services[data.code]
      ) {
        return
      }

      state.mtech.leg1.services[data.code].price = data.val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/mtech.js